// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"86873756","551":"8a9d9a46","752":"86873756"}[chunkId] + ".chunk.css";
};